// extracted by mini-css-extract-plugin
export var cardHeader = "_ge-0";
export var reorderHandle = "_ge-3";
export var titleArea = "_ge-1";
export var titleAreaWithHandle = "_ge-2";